import {
  CHANGE_POP_UP,
  CHANGE_POP_UP_ERROR
} from './actions'

export default function (state = {
  visible: false,
  action: '',
  popUpError: ''
}, action) {
  switch (action.type) {
    case CHANGE_POP_UP:
      return action.payload
    case CHANGE_POP_UP_ERROR:
      return { ...state, popUpError: action.payload }
    default:
      return state
  }
}
